import React from "react";
const Q2 = () => {
  return (
    <div style={{ backgroundColor: "#Dbe6ea" }}>
      <div className="ans-bank">
        <div className="qta">What is T-Shirt giveaway entry period?</div>
        <p>
          This promotion begins on [Date] at[Time] [Time Zone] and ends on
          [Date] at [Time] [Time Zone] (“EntryPeriod”). To be eligible for the
          Giveaway, entries must be received within the specified Entry Period.
        </p>
      </div>
    </div>
  );
};

export default Q2;
